import jwtInterceptor from "./jwtInterceptor";
import {searchLocations} from "./geoApiService";
import {GOV_API_ENDPOINTS, LANDS_LINK_ENDPOINTS} from "../utils/api";

class LandsLinkService {

    async saveLandsLink(landsLink) {
        try{
            return await jwtInterceptor.post(LANDS_LINK_ENDPOINTS.upsert, landsLink).then(response => {
                if(response?.isError === true && response.data.records.length > 0) {
                    return response?.data?.records.shift()
                }
            })
        }
        catch(error){
            throw new Error(error)
        }
    }

    async getEnsoleillementLinkByLand(land) {
        try {
            let solarPotentialUrl;
            if (!land.center.lat || !land.center.lon) {
                throw new Error("Coordonnées manquantes");
            }

                const result = await searchLocations(
                    land.center.lat,
                    land.center.lon
                );

                if (result?.featureId) {
                    solarPotentialUrl = GOV_API_ENDPOINTS.solarPotentialUrl.replace(":featureId", result.featureId);
                }

                return solarPotentialUrl

        }catch(err) {
            throw new PotentialEnsoleillementError(err.message);
        }

    }

}

export const landsLinkService = new LandsLinkService()

export class PotentialEnsoleillementError extends Error {

}